import stationFront from "./assets/station-front.png";
import stationSide from "./assets/station-side.png";

export function Appendix() {
  return (
    <section className="border-t bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14 space-y-10">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">
          Appendix
        </h1>

        <div className="space-y-6">
          <h2 className="text-xl sm:text-2xl font-semibold tracking-tight">
            Station information
          </h2>

          <ul className="space-y-3 text-sm sm:text-base text-foreground/90 list-disc pl-5 marker:text-muted-foreground">
            <li>
              All stations when installed are covered with a protective band.
              The back of the station is completely smooth (no rough or sharp
              edges) and the attachment ends are surrounded by rubber and fabric
              for protection.
            </li>
            <li>A station is approximately 25 kg (55 pounds).</li>
            <li>
              No station will be installed facing a court. It will always be
              facing away from the court and on the opposite side of the fence
              than the court. Thus, there is no possibility for someone playing
              sport to run into the station.
            </li>
            <li>
              Stations are mounted & tied to the posts, so no damage or changes
              are ever made to the poles (no hole drilling, etc.).
            </li>
            <li>
              <strong className="font-semibold">Address:</strong> Most accurate
              address found during Digital Mapping.
            </li>
            <li>
              <strong className="font-semibold">GPS:</strong> Exact location of
              the desired pole for station installation.
            </li>
          </ul>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="aspect-video rounded-lg overflow-hidden border bg-muted">
              <img
                src={stationFront}
                alt="Front view of an installed station"
                className="size-full object-contain"
                loading="lazy"
              />
            </div>
            <div className="aspect-video rounded-lg overflow-hidden border bg-muted">
              <img
                src={stationSide}
                alt="Side view of an installed station"
                className="size-full object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl sm:text-2xl font-semibold tracking-tight">
            How we install
          </h2>
          <div className="relative aspect-video rounded-lg overflow-hidden border bg-black">
            <iframe
              src="https://www.youtube.com/embed/WW8xtne7ENc"
              title="Top band tutorial — Equip Sport Operations"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 h-full w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
